import { Dialog, DialogBody, DialogFooter, DialogHeader, Button } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';

export default function RoomShift({ isOpen, onClose, onSubmit, roomShiftRequest }) {

    const [newRoomNo, setNewRoomNo] = useState("");
    const [newPaymentDetails, setNewPaymentDetails] = useState([]);

    useEffect(() => {
        let priceDetails = [];
        if (newRoomNo) {
            const rc = getRoomDetailsByCategory(roomShiftRequest.currentRoomType);
            const previousRoom = getPreviousRoom(roomShiftRequest.roomNoToChange)
            const priceDetail = {};
            priceDetail.roomNo = newRoomNo;
            priceDetail.category = rc.category;
            priceDetail.fare = previousRoom.totalDays * (previousRoom.unitFare || rc.price);
            priceDetail.extraBedCost = previousRoom.totalDays * previousRoom.extraBeds * rc.extraBedCharges;
            priceDetail.gst = ((previousRoom.totalDays * (previousRoom.unitFare || rc.price)) + priceDetail.extraBedCost) * (rc.gst / 100);
            priceDetail.totalCost = priceDetail.fare + priceDetail.extraBedCost + priceDetail.gst;
            priceDetails.push(priceDetail);
        }
        setNewPaymentDetails(priceDetails);

    }, [newRoomNo]);

    function getRoomDetailsByCategory(category) {
        const rc = roomShiftRequest.roomTypes.find(rc => rc.category === category);
        return rc;
    }

    function getPreviousRoom(roomNo) {
        return roomShiftRequest.card.roomDetails.find(rd => rd.roomNo === roomNo);
    }

    function getPreviousCheckIn(roomNo) {
        return roomShiftRequest.checkIns.find(ck => ck.roomNo === roomNo);
    }

    const handleSubmitInternal = async () => {
        if (newRoomNo) {
            const previousCheckIn = getPreviousCheckIn(roomShiftRequest.roomNoToChange);
            const newCheckIn = JSON.parse(JSON.stringify(previousCheckIn));
            newCheckIn.roomNo = newRoomNo;
            const obsoleteCheckIns = [];
            obsoleteCheckIns.push(previousCheckIn);
            roomShiftRequest.checkIns = [];
            roomShiftRequest.checkIns.push(newCheckIn);
            roomShiftRequest.card.roomDetails.forEach(rd => {
                if (rd.roomNo === roomShiftRequest.roomNoToChange && !rd.closed) {
                    rd.roomNo = newRoomNo;
                }
            });
            await onSubmit(roomShiftRequest.card, roomShiftRequest.checkIns, obsoleteCheckIns);
        }
    };
    return (
        <Dialog open={isOpen}>
            <DialogHeader>Shift room from {roomShiftRequest.roomNoToChange}</DialogHeader>
            <DialogBody>
                <div className="w-full lg:w-12/12 px-4 rounded overflow-scroll">
                    <div className="relative w-full mb-3">
                        <div className="flex flex-wrap border border-gray-300 p-2" >
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor="newRoomNo" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">New Room No<span className="text-red-500">*</span></label>
                                <select label="newRoomNo" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    name="newRoomNo" id="newRoomNo"
                                    onChange={(event) => setNewRoomNo(event.target.value)}
                                    value={newRoomNo}>
                                    <option value="">Select</option>
                                    {roomShiftRequest.availableRooms.map((room, i) => (
                                        <option key={i} value={room}>{room}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor="newCategory" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Same Category</label>
                                <select label="newCategory" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    name="newCategory" id="newCategory" disabled={true} 
                                    onChange={(event) => {}}
                                    value={roomShiftRequest.currentRoomType}>
                                    <option value={roomShiftRequest.currentRoomType}>{roomShiftRequest.currentRoomType}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogBody>
            <DialogFooter>
                <Button
                    variant="text"
                    color="red"
                    onClick={onClose}
                    className="mr-1"
                >
                    <span>Cancel</span>
                </Button>
                <Button variant="gradient" color="green" onClick={handleSubmitInternal}>
                    <span>Save</span>
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
